import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createElement } from 'react';
import { useTranslation } from '@/hooks/useTranslations';
export const Trans = ({ translation, components = {}, }) => {
    const { t } = useTranslation();
    const renderWithComponents = (text, components) => {
        // Split text in multiple part based on placeholders
        const parts = text.split(/(<[^>]+>)/g).filter(Boolean);
        const processParts = (startIndex) => {
            const result = [];
            let index = startIndex;
            while (index < parts.length) {
                const part = parts[index];
                if (part.startsWith('</')) {
                    return [result, index];
                }
                else if (part.startsWith('<') && part.endsWith('>')) {
                    const tagName = part.replace(/[<>/]/g, '');
                    if (components[tagName]) {
                        const [children, newIndex] = processParts(index + 1);
                        index = newIndex;
                        result.push(createElement(components[tagName].type, { key: index, ...components[tagName].props }, children.length > 0 ? children : null));
                    }
                    else {
                        index++;
                    }
                }
                else {
                    result.push(part);
                }
                index++;
            }
            return [result, index];
        };
        const [elements] = processParts(0);
        return elements;
    };
    return _jsx(_Fragment, { children: renderWithComponents(t(translation), components) });
};
